// components/KbBees.jsx
// Playful KB-beekeeper mascot animation built by cycling assets/kb/frame-1..N.png.
//
// The frames are independent mascot variations (not a registered motion
// sequence), so a modest fps reads as a lively hand-drawn "wiggle" rather than
// fluid motion — which suits a one-shot celebration. Drop-in: replacing the
// PNGs with transparent re-exports (same names) composites cleanly with NO code
// change. Mirrors the existing assets/tokens/spin/frame-N.png convention.
import React, { useState, useEffect } from 'react';

const BASE = '/assets/kb/frame-';
const DEFAULT_COUNT = 8;

// Warm the browser cache for the frames. Call this when the bug-report modal
// OPENS (not when this component mounts — by then the user has already hit
// submit) so the cheer plays instantly on success. Idempotent + cheap; the
// browser dedupes repeat requests for already-cached images.
export function preloadKbBees(count = DEFAULT_COUNT) {
  if (typeof Image === 'undefined') return;
  for (let n = 1; n <= count; n++) { const im = new Image(); im.src = `${BASE}${n}.png`; }
}

export default function KbBees({ size = 132, fps = 8, count = DEFAULT_COUNT }) {
  const [idx, setIdx] = useState(0);

  // Belt-and-suspenders: preload on mount too, in case this renders without the
  // open-time warmup (e.g. reused elsewhere). Hits cache when already warmed.
  useEffect(() => { preloadKbBees(count); }, [count]);

  useEffect(() => {
    const id = setInterval(() => setIdx(p => (p + 1) % count), Math.round(1000 / fps));
    return () => clearInterval(id);
  }, [fps, count]);

  return (
    <img
      src={`${BASE}${idx + 1}.png`}
      alt=""
      width={size}
      height={size}
      style={{ display: 'block', margin: '0 auto 6px', objectFit: 'contain' }}
    />
  );
}
